import React, { useRef, useState } from 'react'
import './App.css'
import { Link } from 'react-router-dom'
import Axios from 'axios'
import ClipLoader from 'react-spinners/ClipLoader'
import { useHistory, useLocation } from 'react-router-dom'
import { API_URL } from './config'

const Newpassword = () => {
  const history = useHistory()
  const location = useLocation()
  const { email, accounttype, message, isAffiliate, account_name } = location.state || {}

  const [pass1, setPass1] = useState('')
  const [pass2, setPass2] = useState('')
  const [otp, setOTP] = useState('')
  const [failed, setFailed] = useState('')
  const [success, setSuccess] = useState('')
  const [error, setError] = useState('')
  const [successError, setSuccessError] = useState('')
  const [errorDisplay, setErrorDisplay] = useState('none')
  const [isOTPCorrect, setIsOTPCorrect] = useState(false)
  const [saveBtn, setSaveBtn] = useState('save-btn')
  const [disabled, setDisabled] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isPasswordSaved, setIsPasswordSaved] = useState(false)
  const timeoutRef = useRef(null)

  const handleForm = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    setSaveBtn('btn-disabled')
    setDisabled(true)
    setLoading(true)
    const baseURL = `${API_URL}/apps/kscanner/webservices.php`
    const data = new FormData()
    data.append('email', email)
    data.append('account_type', accounttype)
    data.append('isAffiliate', isAffiliate)

    if (isOTPCorrect) {
      data.append('pass1', pass1)
      data.append('pass2', pass2)
      data.append('account_name', account_name)
      data.append('query', 'SAVE-NEW-PASSWORD')
    } else {
      data.append('otp', otp)
      data.append('query', 'VERIFY-OTP-TO-RESET-PASSWORD')
    }

    Axios({
      method: 'POST',
      url: baseURL,
      data: data,
      withCredentials: true,
    })
      .then((response) => {
        if (response.data.status === 'success') {
          if (isOTPCorrect && response.data.is_new_password_saved === 'yes') {
            setIsPasswordSaved(true)
          } else {
            setError(response.data.message)
            setErrorDisplay('block')
            setSuccessError('success-login')

            setIsOTPCorrect(true)
          }
        } else {
          setError(response.data.message)
          setErrorDisplay('block')
          setSuccessError('error-login')
        }
        setSaveBtn('save-btn')
        setDisabled(false)
        setLoading(false)
      })
      .catch((error) => {
        setIsOTPCorrect(false)
        setErrorDisplay('none')
        setSaveBtn('save-btn')
        setDisabled(false)
        setLoading(false)
        alert(error)
      })

    timeoutRef.current = setTimeout(() => {
      setErrorDisplay('none')
    }, 5000)
  }

  return (
    <div className="view">
      {/* <Header /> */}
      <div className="container">
        <div className="row justify-content-center align-content-center w-100 login-screen-container">
          <div className="col-lg-5 col-12 login-container-adjust">
            <div className="log-title text-center">
              <Link to="/">
                <img src={`${API_URL}/karamale.png`} width="170" />
              </Link>
            </div>
            {isPasswordSaved ? (
              <div className="card">
                <h2>
                  ✅ <br />
                  New password saved
                </h2>
                <p>Your new password has been saved successfully.</p>
                <p>
                  <a href={`${API_URL}/login`}>Proceed to log in</a>
                </p>
              </div>
            ) : (
              <>
                <div className=" BoxDashboardContainer">
                  {isOTPCorrect && (
                    <>
                      <input
                        type="password"
                        name="pass1"
                        required
                        placeholder="New password"
                        onChange={(e) => setPass1(e.target.value)}
                        value={pass1}
                      />

                      <input
                        type="password"
                        name="pass2"
                        required
                        placeholder="Confirm password"
                        onChange={(e) => setPass2(e.target.value)}
                        value={pass2}
                      />
                    </>
                  )}

                  {!isOTPCorrect && (
                    <>
                      <div className="alert alert-success p-2">{message}</div>
                      <input
                        type="text"
                        name="code"
                        required
                        placeholder="Enter OTP to verify your identity"
                        onChange={(e) => setOTP(e.target.value)}
                        value={otp}
                      />
                    </>
                  )}
                  <div
                    className=""
                    style={{
                      padding: 10,
                      paddingLeft: 0,
                      paddingTop: 0,
                      paddingBottom: 0,
                      color: 'red',
                    }}
                  >
                    {failed}
                  </div>
                  <div
                    className=""
                    style={{
                      padding: 10,
                      paddingLeft: 0,
                      paddingTop: 0,
                      color: 'green',
                    }}
                  >
                    {success}
                  </div>
                  <button
                    onClick={() => handleForm()}
                    className={saveBtn + ' w-100 mb-3'}
                    disabled={disabled}
                  >
                    {!loading && <span>{isOTPCorrect ? 'Save password' : 'Verify identity'}</span>}

                    {loading && (
                      <span>
                        <ClipLoader
                          color={'grey'}
                          loading={true}
                          // css={override}
                          size={20}
                        />
                      </span>
                    )}
                  </button>
                  <Link to="/login" style={{ textDecoration: 'none' }}>
                    <div className="text-center cancel-btn">Log in</div>
                  </Link>
                </div>

                <div className="text-footer text-center">
                  Set new <span>password</span> and resume where you left off
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className={successError} style={{ display: errorDisplay, textAlign: 'center' }}>
        {error}
      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default Newpassword
